import _ from 'lodash';
import { addSharedAxios } from '../view-stack/utils/support';

// All branches by id -> name
addSharedAxios('branches', '/api/branches', {}, data => _.reduce(data, (obj, branch) => {
  obj[branch.id] = branch.name;
  return obj;
}, { 0: 'Global' }));

// All users that are teachers
addSharedAxios('teachers', '/api/users?for=role&role=teacher', []);

// All currently available courses
addSharedAxios('courses', `/api/user/courses/${window.KwIntern.id}`, []);

// All registered roles
addSharedAxios('roles', '/api/roles', []);



// WEBPACK FOOTER //
// ./resources/assets/js/api/index.js